import React from "react";

import { TabType, MOBILE } from "@constants";

import { FiltersProps, IconsListProps } from "../../../types";

import FiltersMobileCloseHandle from "./FiltersMobileCloseHandle";
import FiltersMobileCloseButton from "./FiltersMobileCloseButton";
import FiltersMobileFormBranches from "./FiltersMobileFormBranches";
import FiltersMobileFormAtms from "./FiltersMobileFormAtms";

type FiltersMobileDropdownProps = {
  type: TabType;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & FiltersProps &
  IconsListProps;

const FILTERS_HEADER_MOBILE = "filters-header-mobile";
const FILTERS_BODY_MOBILE = "filters-body-mobile";

const FiltersMobileDropdown: React.FC<FiltersMobileDropdownProps> = ({
  type,
  filters,
  iconsList,
  handleOnChange,
}) => {
  return (
    <div id={`filters-dropdown-all-${MOBILE}-${type}`} className="hidden">
      <div id={FILTERS_HEADER_MOBILE} className={FILTERS_HEADER_MOBILE}>
        <FiltersMobileCloseHandle type={type} />
        <FiltersMobileCloseButton iconsList={iconsList} type={type} />
      </div>
      <div id={FILTERS_BODY_MOBILE} className={FILTERS_BODY_MOBILE}>
        {type === TabType.Branches ? (
          <FiltersMobileFormBranches
            type={TabType.Branches}
            filters={filters}
            handleOnChange={handleOnChange}
          />
        ) : (
          <FiltersMobileFormAtms
            type={TabType.Atms}
            filters={filters}
            handleOnChange={handleOnChange}
          />
        )}
      </div>
    </div>
  );
};

export default FiltersMobileDropdown;
